import styled from '@emotion/styled/macro';
import { BaseButton, Popover, PopoverDivider, PopoverItem, Variables } from '@enter/core';
import { Icon } from '@mdi/react';

export const UserButton = styled(BaseButton)`
    height: 40px;
    width: 40px;
`;

export const StyledIcon = styled(Icon)`
    height: 24px;
    width: 24px;
`;

export const UserPopover = styled(Popover)``;

export const PopoverNameItem = styled(PopoverItem)`
    display: flex;
    flex-direction: column;
    padding: 16px 24px;
`;

export const PopoverLogoutItem = styled(PopoverItem)`
    display: flex;
    flex-direction: column;
    line-height: 32px;
    padding: 0px 24px;
    margin: 8px 0;

    &:hover {
        cursor: pointer;
        background-color: ${Variables.Colors.n15_24};
    }
`;

export const StyledPopoverDivider = styled(PopoverDivider)`
    padding: 8px 0;
    margin: 0;
    min-width: 240px;
`;

export const UserField = styled.span`
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.2px;
    color: ${Variables.Colors.n100};
    margin-bottom: 4px;
`;

export const UserValue = styled.span`
    font-size: 16px;
    letter-spacing: 0.2px;
    color: ${Variables.Colors.n70};
`;
